/* ==========================================================================
   SARAURA — "SELECT A SIZE" HAS TO GO SOMEWHERE
   Loaded on product templates, after sr-pdp.js.

   THE BUG, EXACTLY.
   The sticky bar at the foot of a product page carries a real submit button
   for the buy form. sr-pdp.js gates that submit properly:

     if (SPOS && !chosenSize()) {
       e.preventDefault();
       if (sizeErr) sizeErr.textContent = 'Choose a size first.';
       var first = sizeInputs.filter(...)[0];
       if (first) first.focus({ preventScroll: false });
       return;
     }

   Every line of that is right, and on a phone it does nothing you can see.
   The size controls are <label class="pd-size"> wrapping an <input> that is
   .sr-sr-only — clipped to a single pixel. focus() lands on a 1px element, so
   the browser has almost nothing to scroll to, and the error line it wrote is
   several screens above the bar that was just tapped. The customer taps
   SELECT A SIZE and the page sits still.

   THE FIX. Take them to the option they have not answered. This listens on
   the capture phase so it runs before the gate. The fieldset is marked with
   .pd-opt--asking for a moment on arrival, which sr-pdp-fix.css draws as a
   ring — box-shadow only, so nothing it highlights moves.

   AND IT NOW STOPS THE SUBMIT, which it deliberately did not before. That
   changed because of what was measured on the live site, below.
   ==========================================================================

   THE SECOND BUG, AND IT WAS SELLING THE WRONG DRESS
   --------------------------------------------------------------------------
   This product has THREE options: Style, Color, Size. sr-pdp.js gates the
   submit on ONE of them:

       if (SPOS && !chosenSize()) { e.preventDefault(); ... }

   Nothing checks Style. Measured on the published theme, in the browser:
   choose Color = Black and Size = XS, leave Style alone — which a customer
   easily does, since the photographs already show a style — and press the
   button. The form submits. Not prevented. Variant 57066987618628, which is

       Strap / White / XS

   Wrong style AND wrong colour. She asked for a black dress and the cart took
   a white one.

   syncVariant() does its part correctly: with Style unanswered it refuses to
   resolve a variant and leaves .pd--sized off, so the button still reads
   "Select options". But the button is a real submit button whatever its label
   says, and the hidden id field still holds the default Liquid rendered —
   product.selected_or_first_available_variant. Pressing it posts that.

   sr-pdp.js already carries a comment about this exact failure: "An unchosen
   Style used to mean 'whichever variant sorted first', which is how a customer
   who read the Slim Fit chart was sold a Strap." That was fixed in
   syncVariant. It was never fixed in the gate.

   THE RULE HERE IS DELIBERATELY DUMB, because it stands between a customer
   and a purchase and must not have opinions: if a radio group exists and
   nothing in it is chosen, do not submit. It reads no variant data, knows
   nothing about availability, and cannot block a product that has no options
   or one whose groups are all answered. The worst it can do is ask.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;

  function ready(fn) {
    if (doc.readyState !== 'loading') { fn(); }
    else { doc.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    /* EVERY radio group on the buy form, in the order the customer reads them.
       Not just the size one: a group is a group, and an unanswered Style costs
       exactly as much as an unanswered size. */
    function groups() {
      return [].slice.call(doc.querySelectorAll('form[action*="/cart/add"] fieldset.pd-opt'))
        .filter(function (fs) { return fs.querySelector('input[type="radio"]'); });
    }

    /* The first group with nothing chosen in it, or null if they are all
       answered. A disabled radio does not count as an answer — sr-pdp.js
       un-checks a selection that has become unavailable, and that is exactly
       the moment we need to ask again. */
    function firstUnchosen() {
      var g = groups();
      for (var i = 0; i < g.length; i++) {
        if (!g[i].querySelector('input[type="radio"]:checked:not([disabled])')) { return g[i]; }
      }
      return null;
    }

    /* The legend carries the option's name and, in a nested span, its current
       value — "ColorWhite" read as text. The first text node is the name. */
    function nameOf(fs) {
      var lg = fs.querySelector('legend');
      if (!lg) { return ''; }
      for (var i = 0; i < lg.childNodes.length; i++) {
        if (lg.childNodes[i].nodeType === 3) {
          var t = lg.childNodes[i].nodeValue.trim();
          if (t) { return t; }
        }
      }
      return (lg.textContent || '').trim();
    }

    if (!groups().length) { return; }

    var bar = doc.getElementById('pd-stickybar');
    var timer = null;

    function jump(sizeset) {
      if (!sizeset) { return; }
      var rect = sizeset.getBoundingClientRect();
      var barH = (bar && !bar.hidden && bar.classList.contains('is-in')) ? bar.offsetHeight : 0;

      /* Centre it in what is left of the screen above the bar, but never let
         the header crop the legend: 24px is the floor. */
      var room = window.innerHeight - barH - rect.height;
      var offset = room > 48 ? (room / 2) : 24;
      var top = window.scrollY + rect.top - offset;
      if (top < 0) { top = 0; }

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try {
        window.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
      } catch (e) {
        window.scrollTo(0, top);
      }

      sizeset.classList.remove('pd-opt--asking');
      /* Reading offsetWidth restarts the animation if it is already running,
         so a second tap flashes again rather than doing nothing. */
      void sizeset.offsetWidth;
      sizeset.classList.add('pd-opt--asking');

      if (timer) { clearTimeout(timer); }
      timer = setTimeout(function () {
        sizeset.classList.remove('pd-opt--asking');
      }, 1600);
    }

    /* Written into whichever error line the unanswered fieldset points at, so
       the message lands under the question rather than under the size list.

       ONLY THE SIZE FIELDSET HAS ONE. Measured: aria-describedby is
       [null, null, "pd-sizeerr"] — Color and Style have nowhere to put a
       sentence, so blocking them gave a customer a silent ring and a page
       that jumped. She is owed the reason in words. One is made here, in the
       markup the size line already uses, and wired up for a screen reader
       too. */
    var made = 0;
    function lineFor(fs) {
      var id = fs.getAttribute('aria-describedby');
      var line = id ? doc.getElementById(id) : null;
      if (line) { return line; }
      line = doc.createElement('p');
      line.className = 'sr-caption pd-sizeerr';
      line.id = 'pd-opterr-' + (++made);
      line.setAttribute('role', 'alert');
      line.setAttribute('data-pd-guarderr', '');
      fs.appendChild(line);
      fs.setAttribute('aria-describedby', line.id);
      return line;
    }

    function ask(fs) {
      var line = lineFor(fs);
      if (!line) { return; }
      var n = nameOf(fs);
      line.textContent = n ? ('Choose a ' + n.toLowerCase() + ' first.') : 'Choose an option first.';
    }

    /* Clear the moment she answers, so a message cannot outlive the question
       it was asking. sr-pdp.js clears its own; these are ours to clear. */
    doc.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') { return; }
      [].forEach.call(doc.querySelectorAll('[data-pd-guarderr]'), function (p) { p.textContent = ''; });
    }, true);

    function guard(e) {
      var missing = firstUnchosen();
      if (!missing) { return; }          /* everything answered — never interfere */

      /* THE STOP. Without this the form posts the default variant Liquid
         rendered, which is not the one she picked. */
      e.preventDefault();
      /* Immediate, so sr-pdp.js's own handler cannot post it either. This file
         loads after sr-pdp.js, but capture-phase listeners on different
         targets still run outermost-first, and stopping here is the only way
         to be sure nothing downstream submits. */
      if (e.stopImmediatePropagation) { e.stopImmediatePropagation(); }

      ask(missing);
      /* Deferred by a tick so it lands after any focus() the page does to
         itself, rather than fighting it. */
      setTimeout(function () { jump(missing); }, 0);
    }

    doc.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('.pd-atc')) { return; }
      guard(e);
    }, true);

    /* The keyboard route into the same form. Enter in a text field submits
       without ever pressing the button. */
    var form = doc.querySelector('form[action*="/cart/add"]');
    if (form) { form.addEventListener('submit', guard, true); }
  });
}());

/* ==========================================================================
   SARAURA — TOUCH FOR THE ENLARGED PHOTOGRAPH
   --------------------------------------------------------------------------
   sr-pdp.js builds the lightbox and binds a close, a previous, a next, a
   magnify button and the arrow keys. What it never had was a finger: no
   swipe between photographs, and no pinch. On a phone — which is where this
   shop is mostly read — the enlarged view was a dead end you could only leave.

   This adds three gestures and NOTHING else. It does not re-implement the
   gallery: to change photograph it clicks the buttons sr-pdp.js already owns,
   so the counter, the thumbnails and the colourway filter all stay in step
   without this file knowing anything about them.

     · swipe left / right   → next / previous photograph
     · pinch                → zoom between 1x and 3x, then drag to pan
     · double tap           → 2x, or back to fit

   Loaded after sr-pdp.js, which is what makes the elements exist.
   ========================================================================== */
(function () {
  'use strict';
  var doc = document;
  var lb = doc.getElementById('pd-lightbox');
  if (!lb) return;

  var frame = doc.getElementById('pd-lightbox-frame');
  var prev  = doc.getElementById('pd-lightbox-prev');
  var next  = doc.getElementById('pd-lightbox-next');
  if (!frame) return;

  var SWIPE = 45;      /* px before a drag counts as a swipe             */
  var SLOPE = 1.2;     /* horizontal must beat vertical by this to count */
  var zoom = 1;

  function img() { return frame.querySelector('img'); }

  /* Centre the scroll on the middle of the picture after a zoom, so growing
     it does not throw the customer to the top-left corner of the fabric. */
  function recentre(fx, fy) {
    var i = img();
    if (!i) return;
    requestAnimationFrame(function () {
      frame.scrollLeft = (frame.scrollWidth  - frame.clientWidth)  * (fx == null ? 0.5 : fx);
      frame.scrollTop  = (frame.scrollHeight - frame.clientHeight) * (fy == null ? 0.5 : fy);
    });
  }

  function setZoom(z, fx, fy) {
    zoom = Math.min(3, Math.max(1, z));
    if (zoom <= 1.02) {
      zoom = 1;
      lb.classList.remove('is-mag');
      frame.style.removeProperty('--pd-zoom');
    } else {
      lb.classList.add('is-mag');
      frame.style.setProperty('--pd-zoom', zoom.toFixed(3));
      recentre(fx, fy);
    }
  }

  /* sr-pdp.js toggles .is-mag from its own button and from a click on the
     image. Watch for that so this file's idea of the zoom cannot drift out of
     step with the class actually on the element. */
  new MutationObserver(function () {
    var on = lb.classList.contains('is-mag');
    if (on && zoom === 1) { zoom = 2; frame.style.setProperty('--pd-zoom', '2'); recentre(); }
    if (!on && zoom !== 1) { zoom = 1; frame.style.removeProperty('--pd-zoom'); }
  }).observe(lb, { attributes: true, attributeFilter: ['class'] });

  var x0 = 0, y0 = 0, t0 = 0, moved = false, pinch0 = 0, zoom0 = 1, taps = 0, tapAt = 0;

  function dist(t) {
    var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  frame.addEventListener('touchstart', function (e) {
    if (e.touches.length === 2) {
      pinch0 = dist(e.touches);
      zoom0 = zoom;
      moved = true;
      return;
    }
    x0 = e.touches[0].clientX;
    y0 = e.touches[0].clientY;
    t0 = e.timeStamp;
    moved = false;
    pinch0 = 0;
  }, { passive: true });

  frame.addEventListener('touchmove', function (e) {
    if (e.touches.length === 2 && pinch0) {
      e.preventDefault();
      var r = frame.getBoundingClientRect();
      var cx = ((e.touches[0].clientX + e.touches[1].clientX) / 2 - r.left) / r.width;
      var cy = ((e.touches[0].clientY + e.touches[1].clientY) / 2 - r.top) / r.height;
      setZoom(zoom0 * (dist(e.touches) / pinch0), cx, cy);
      moved = true;
      return;
    }
    if (e.touches.length !== 1) return;
    var dx = e.touches[0].clientX - x0;
    var dy = e.touches[0].clientY - y0;
    if (Math.abs(dx) > 8 || Math.abs(dy) > 8) moved = true;
    /* While magnified the frame scrolls, so let the browser do the panning. */
    if (zoom > 1) return;
    if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy) * SLOPE) e.preventDefault();
  }, { passive: false });

  frame.addEventListener('touchend', function (e) {
    if (pinch0) { pinch0 = 0; return; }
    var t = e.changedTouches[0];
    var dx = t.clientX - x0;
    var dy = t.clientY - y0;

    if (zoom === 1 && Math.abs(dx) > SWIPE && Math.abs(dx) > Math.abs(dy) * SLOPE) {
      /* A swipe must not also read as the tap that magnifies. */
      e.preventDefault();
      if (dx < 0) { if (next) next.click(); }
      else        { if (prev) prev.click(); }
      taps = 0;
      return;
    }

    if (moved || e.timeStamp - t0 > 400) { taps = 0; return; }

    /* Double tap. The first tap is left to sr-pdp.js, which magnifies on
       click; the second is caught here and returns the picture to fit. */
    if (e.timeStamp - tapAt < 320) {
      e.preventDefault();
      setZoom(zoom > 1 ? 1 : 2, (t.clientX - frame.getBoundingClientRect().left) / frame.clientWidth, 0.5);
      taps = 0; tapAt = 0;
      return;
    }
    tapAt = e.timeStamp;
  }, { passive: false });

  /* Reset the zoom whenever the photograph changes, so the next one opens
     showing the whole garment rather than wherever the last pinch left off. */
  [prev, next].forEach(function (b) {
    if (b) b.addEventListener('click', function () { setZoom(1); frame.scrollTop = 0; frame.scrollLeft = 0; });
  });
}());
